import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core';

interface IData {
  message: string;
  color: string;
}

@Component({
  selector: 'app-info-modal',
  imports: [],
  templateUrl: './info-modal.html',
  styleUrl: './info-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModal {
  protected readonly data = signal<IData | null>(null);

  setData(data: IData) {
    this.data.set(data);
  }
}
